/*
*
* File JS Principale
*
*/
// IMPORT JQUERY
//--------------------------------------------------------------------//

import $ from 'jquery';




// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import 'scss/app.scss';

//--------------------------------------------------------------------//

// Carichiamo i font in maniera asincrona
//--------------------------------------------------------------------//

var Webfont = require('webfontloader');

Webfont.load({
    typekit: {
        id: 'lkz4zns',
    }
});

//--------------------------------------------------------------------//

// Libreria Lazysizes
//--------------------------------------------------------------------//
import 'lazysizes';

//--------------------------------------------------------------------//

// Import Utilies
//--------------------------------------------------------------------//

import { initSvgImage } from './utilities/img-svg';
// import smoothScroll from './utilities/smooth-scroll';
// import initAnimations from './utilities/animations';

//--------------------------------------------------------------------//


// Init Utilies
//--------------------------------------------------------------------//

initSvgImage();

// smoothScroll();

// initAnimations();

//--------------------------------------------------------------------//


// Import Componenti
//--------------------------------------------------------------------//

import topBarInit from 'components/top-bar/top-bar';

import initHeader from 'components/header/header';

// import searchBar from 'components/search-bar/search-bar';

import hero from 'components/hero/hero';

import footer from 'components/footer/footer';

import pagination from 'components/pagination/pagination';

import accordion from 'imComponents/accordion/accordion';
import videoBlock from "components/video-block/video-block";
import textBlock from "components/text-block/text-block";
import productsSlider from "components/products-slider/products-slider";
import productCard from "components/product-card/product-card";
import newsCard from "components/news-card/news-card";
import newsSlider from "components/news-slider/news-slider";
import paragraphBanner from "components/paragraph-banner/paragraph-banner";
import wineDescription from "components/wine-description/wine-description";
import infoTable from "components/info-table/info-table";
import wineSlider from "components/wine-slider/wine-slider";
import newWineSlider from "components/new-wine-slider/new-wine-slider";
import newsCardList from "components/news-card-list/news-card-list";
import gallerySlider from "components/gallery-slider/gallery-slider";
import productsList from "components/products-list/products-list";
import oilDescription from "components/oil-description/oil-description";
import timelineSlider from "components/timeline-slider/timeline-slider";
import discover from "components/discover/discover";
import imageSection from "components/image-section/image-section";
import territoryExperienceCard from "components/territory-experience-card/territory-experience-card";
import territoryExperienceSlider from "components/territory-experience-slider/territory-experience-slider";
import experienceCardList from "components/experience-card-list/experience-card-list";
import experienceCard from "components/experience-card/experience-card";
import downloadFileBlock from "components/download-file-block/download-file-block";
import cf7Form from "components/cf7-form/cf7-form";
import prizeSlider from "components/prize-slider/prize-slider";
import languageList from "components/language-list/language-list";
import smallCards from "components/small-cards/small-cards";

//--------------------------------------------------------------------//


// Init Componenti
//--------------------------------------------------------------------//

topBarInit();

footer();

initHeader();

accordion();

// searchBar();

hero();

videoBlock();

textBlock();

productsSlider();

productCard();

newsCard();

newsSlider();

paragraphBanner();

wineDescription();

infoTable();

wineSlider();

newWineSlider();

newsCardList();

gallerySlider();

productsList();

oilDescription();

timelineSlider();

discover();

imageSection();

territoryExperienceCard();

territoryExperienceSlider();

experienceCardList();

experienceCard();

downloadFileBlock();

cf7Form();

prizeSlider();
//--------------------------------------------------------------------//